import { combineReducers } from "redux";
import AppReducer from "./app/app.reducer";
import AuthReducer from "./auth/auth.reducer";
import formReducer from "./formReducer";

const rootReducer = combineReducers({
  app: AppReducer,
  auth: AuthReducer,
  form: formReducer,
});

export default rootReducer;
